// src/api/recipeTemplate.api.ts
import { get, post, put, del } from './client';

export const recipeTemplateApi = {
  // Get all templates (paginated)
  getAllTemplates: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    sortBy?: string;
    sortOrder?: string;
  }) => get('/templates', { params }),

  // Get template by ID (includes items with material info)
  getTemplateById: (id: string) => get(`/templates/${id}`),

  // Create template with items
  createTemplate: (data: {
    name: string;
    description?: string;
    items: {
      materialId: string;
      quantity: number;
      unitType: string;
    }[];
  }) => post('/templates', data),

  // Update template
  updateTemplate: (id: string, data: {
    name?: string;
    description?: string | null;
    items?: {
      id?: string;
      materialId: string;
      quantity: number;
      unitType: string;
    }[];
  }) => put(`/templates/${id}`, data),

  // Delete template
  deleteTemplate: (id: string) => del(`/templates/${id}`),

  // Calculate ingredient cost
  calculateCost: (id: string) => get(`/templates/${id}/cost`),

  // Check ingredient availability
  checkAvailability: (id: string) => get(`/templates/${id}/availability`),
};
